import React, { useEffect, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import { superAxiosRequest } from 'axiosApi'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import THead from 'components/ContentBox/Global/ReportTable/THead'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import st from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import useLocalization from 'hooks/useLocalization'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { observer } from 'mobx-react'

const DroppedStudents = () => {
  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const [catalog, setCatalog] = useState({})
  const history = useHistory()
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const filterCnf = [
    {
      type: 'select-multi',
      label: 'Локация',
      placeholder: 'Локация',
      values: catalog?.locations,
      sort_key: 'name',
      nameState: 'location',
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
      isRequired: true,
    },
    {
      type: 'type_selector',
      nameState: 'online',
      label: 'Формат',
      values: [
        { id: 2, name: 'Все группы' },
        { id: 1, name: 'Онлайн' },
        { id: 0, name: 'Офлайн' },
      ],
    },
    {
      type: 'select-multi',
      label: 'Уровень курса',
      placeholder: 'Уровень курса',
      values: catalog?.course_levels,
      sort_key: 'name',
      nameState: 'course_level',
    },
    {
      type: 'select-multi',
      label: 'Уровень группы',
      placeholder: 'Уровень группы',
      values: catalog?.skill_levels,
      sort_key: 'name',
      nameState: 'skill_level',
    },
    {
      type: 'select-multi',
      label: 'Статус студента',
      placeholder: 'Статус студента',
      nameState: 'student_status',
      values: [
        { id: 2, name: 'Закончил обучение' },
        { id: 3, name: 'Прервал обучение' },
        { id: 4, name: 'Без занятий' },
        { id: 5, name: 'Удалённый' },
      ],
    },
  ]

  const cols = [
    {
      name: 'Ф.И.О. студента',
    },
    { name: 'Школа', rowSpan: 3 },
    { name: 'Группа', rowSpan: 3 },
  ]

  const findLocationName = ({ result, locations }) => {
    setData(
      result.map((row) => ({
        ...row,
        location_name: locations.find((loc) => loc.id === row.group.location_id)
          .name,
      })),
    )
  }

  useEffect(() => {
    setIsLoading(true)

    const params = {
      ...filter,
    }

    if (params.skill_level && params.skill_level.length > 0)
      params.skill_level = `[${params.skill_level.map((item) => item)}]`
    if (params.course_level && params.course_level.length > 0)
      params.course_level = `[${params.course_level.map((item) => item)}]`
    if (params.location && params.location.length > 0)
      params.location = `[${params.location.map((item) => item)}]`
    if (params.student_status && params.student_status.length > 0)
      params.student_status = `[${params.student_status.map((item) => item)}]`

    const apiConf = {
      method: 'get',
      link: 'groups/student_status_changes',
      params: params,
    }
    superAxiosRequest(apiConf)
      .then((res) => {
        findLocationName(res.data)
        setCatalog(res.data)
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/dropped_students') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const headRow = [
        {
          v: 'Ф.И.О. студента',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Школа',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Группа',
          ...ExcelRowsParams.headerRowParam,
        },
      ]

      const tableData = data.map((row) => [
        {
          v: `${row.student.name}`,
          ...ExcelRowsParams.tableRowParam.firstCell,
        },
        {
          v: `${row.location_name}`,
          ...ExcelRowsParams.tableRowParam.cell,
        },
        {
          v: `${row.group.name}`,
          ...ExcelRowsParams.tableRowParam.cell,
        },
      ])

      const footerRow = [
        {
          v: `ИТОГО ВЫБЫВШИХ СТУДЕНТОВ`,
          ...ExcelRowsParams.footerRowParams.firstCell,
        },
        {
          v: `${data.length}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: ``,
          ...ExcelRowsParams.footerRowParams.cell,
        },
      ]

      const merges = []

      const cols = [{ wch: 40 }, { wch: 30 }, { wch: 50 }]
      const rows = [{ hpx: 30 }]

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData, footerRow])
      ws['!cols'] = cols
      ws['!rows'] = rows
      ws['!merges'] = merges

      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Выбывшие студенты.xlsx')
    })
  }

  const isFilterEmpty = !filterTextValues.length

  return (
    <div>
      <ContentHeader title='Выбывшие студенты' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>

      {isLoading ? (
        <Loader />
      ) : data && data.length > 0 ? (
        <>
          <div style={{ padding: '10px' }}>
            <ExportExcelButton data={data} downloadExcel={downloadExcel} />
          </div>
          <div className={st.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={st.sticky}>
              <table className={st.table}>
                <THead cols={cols} />
              </table>
            </div>
            <table className={`${st.table} ${st.tbodyStriped}`}>
              <THead cols={cols} ref={refThead} />
              <tbody className={st.tbody}>
                {Array.isArray(data) && (
                  <>
                    <tr className={st.bdt}>
                      <td className={`${st.tdTotal} ${st.bdrN} ${st.ttu}`}>
                        Итого выбывших студентов
                      </td>
                      <td
                        className={`${st.tdTotal} ${st.bdlN} ${st.bdrN} ${st.textAlignCenter}`}
                      >
                        {data.length}
                      </td>
                      <td
                        className={`${st.tdTotal} ${st.bdlN} ${st.bdrN} ${st.textAlignCenter}`}
                      />
                    </tr>
                    {data.map((row, rowIdx) => (
                      <tr key={rowIdx} className={st.bdt}>
                        <td
                          className={st.fw600}
                          style={{ background: 'white' }}
                        >
                          <div
                            className={`${st.groupDescription} ${st.medium}`}
                          >
                            <NavLink
                              to={'/account_clients/' + row.student.user_id}
                              target='_blank'
                            >
                              {row.student.name}
                            </NavLink>
                          </div>
                        </td>
                        <td className={`${st.tdMiddle} ${st.textAlignCenter}`}>
                          <div
                            className={`${st.groupDescription} ${st.medium}`}
                          >
                            {row.location_name}
                          </div>
                        </td>
                        <td className={`${st.tdMiddle} ${st.textAlignCenter}`}>
                          <div
                            className={`${st.groupDescription} ${st.bottom}`}
                          >
                            <NavLink
                              to={'/groups/group/' + row.group.id}
                              target='_blank'
                            >
                              {row.group.name}
                            </NavLink>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      )}
    </div>
  )
}

export default observer(DroppedStudents)
